import React from "react";
import { RouteGuard } from "../../guards/RouteGuard";
import { PeriodicalChecksList } from "./PeriodicalChecksList";
function PeriodicalChecks() {
    return (React.createElement(RouteGuard, null,
        React.createElement(PeriodicalChecksList, null)));
}
export default PeriodicalChecks;
